import { z } from 'zod';
export const DSLExistsQueryDTO = z.object({
  exists: z.object({
    field: z.string(),
  }),
});

export type DSLExistsQuery = z.infer<typeof DSLExistsQueryDTO>;